import { BuylistItem, BuylistFilters, PriceFilter, PriceRangeResponse, PagedResponse } from '../types';

// Extended type with category tags for internal filtering
interface MockBuylistItem extends BuylistItem {
  topCommander: boolean;
  topEdhCard: boolean;
  modernStaple: boolean;
  premodernStaple: boolean;
  reservedList: boolean;
  gameChanger: boolean;
}

export const isMockMode = (): boolean =>
  process.env.REACT_APP_USE_MOCK_DATA === 'true';

const MOCK_ITEMS: MockBuylistItem[] = [
  // --- Modern Staples ---
  {
    buylistID: 1, cardBlueprintId: 1001, blueprintName: 'Ragavan, Nimble Pilferer', blueprintVersion: '',
    expansionName: 'Modern Horizons 2', foil: false, maxQuantity: 4, buyPrice: 450.00, buylistStoreCreditPrice: 495.00,
    image_url: 'https://cards.scryfall.io/normal/front/a/9/a9738cda-adb1-47fb-9f4c-ecd930228c4d.jpg?1681963138',
    topCommander: false, topEdhCard: false, modernStaple: true, premodernStaple: false, reservedList: false, gameChanger: false,
  },
  {
    buylistID: 2, cardBlueprintId: 1002, blueprintName: 'Wrenn and Six', blueprintVersion: '',
    expansionName: 'Double Masters 2022', foil: false, maxQuantity: 4, buyPrice: 380.00, buylistStoreCreditPrice: 418.00,
    image_url: 'https://cards.scryfall.io/normal/front/5/b/5bd498cc-a609-4457-9325-6888d59ca36f.jpg?1673149294',
    topCommander: false, topEdhCard: false, modernStaple: true, premodernStaple: false, reservedList: false, gameChanger: false,
  },
  {
    buylistID: 3, cardBlueprintId: 1003, blueprintName: 'Murktide Regent', blueprintVersion: '',
    expansionName: 'Modern Horizons 2', foil: false, maxQuantity: 8, buyPrice: 120.00, buylistStoreCreditPrice: 132.00,
    image_url: 'https://cards.scryfall.io/normal/front/2/0/20c4aae1-7665-4df7-bd51-a1d95bf8a17d.jpg?1626094651',
    topCommander: false, topEdhCard: false, modernStaple: true, premodernStaple: false, reservedList: false, gameChanger: false,
  },
  {
    buylistID: 4, cardBlueprintId: 1004, blueprintName: 'Orcish Bowmasters', blueprintVersion: '',
    expansionName: 'The Lord of the Rings: Tales of Middle-earth', foil: false, maxQuantity: 8, buyPrice: 280.00, buylistStoreCreditPrice: 308.00,
    image_url: 'https://cards.scryfall.io/normal/front/7/c/7c024bae-5631-4e20-ac69-df392ac9e109.jpg?1745319944',
    topCommander: false, topEdhCard: true, modernStaple: true, premodernStaple: false, reservedList: false, gameChanger: false,
  },
  {
    buylistID: 5, cardBlueprintId: 1005, blueprintName: 'The One Ring', blueprintVersion: '',
    expansionName: 'The Lord of the Rings: Tales of Middle-earth', foil: false, maxQuantity: 4, buyPrice: 520.00, buylistStoreCreditPrice: 572.00,
    image_url: 'https://cards.scryfall.io/normal/front/d/5/d5806e68-1054-458e-866d-1f2470f682b2.jpg?1763472900',
    topCommander: false, topEdhCard: false, modernStaple: true, premodernStaple: false, reservedList: false, gameChanger: true,
  },
  {
    buylistID: 6, cardBlueprintId: 1006, blueprintName: 'Solitude', blueprintVersion: '',
    expansionName: 'Modern Horizons 2', foil: false, maxQuantity: 8, buyPrice: 95.00, buylistStoreCreditPrice: 104.50,
    image_url: 'https://cards.scryfall.io/normal/front/4/7/47a6234f-309f-4e03-9263-66da48b57153.jpg?1763472875',
    topCommander: false, topEdhCard: false, modernStaple: true, premodernStaple: false, reservedList: false, gameChanger: false,
  },
  {
    buylistID: 7, cardBlueprintId: 1007, blueprintName: 'Urza\'s Saga', blueprintVersion: '',
    expansionName: 'Modern Horizons 2', foil: false, maxQuantity: 4, buyPrice: 250.00, buylistStoreCreditPrice: 275.00,
    image_url: 'https://cards.scryfall.io/normal/front/c/1/c1e0f201-42cb-46a1-901a-65bb4fc18f6c.jpg?1667318301',
    topCommander: false, topEdhCard: false, modernStaple: true, premodernStaple: false, reservedList: false, gameChanger: false,
  },
  {
    buylistID: 8, cardBlueprintId: 1008, blueprintName: 'Chalice of the Void', blueprintVersion: '',
    expansionName: 'Masters 25', foil: false, maxQuantity: 4, buyPrice: 310.00, buylistStoreCreditPrice: 341.00,
    image_url: 'https://cards.scryfall.io/normal/front/1/f/1f0d2e8e-c8f2-4b31-a6ba-6283fc8740d4.jpg?1562433485',
    topCommander: false, topEdhCard: false, modernStaple: true, premodernStaple: false, reservedList: false, gameChanger: false,
  },

  // --- Top Commander (popular commanders) ---
  {
    buylistID: 9, cardBlueprintId: 1009, blueprintName: 'Atraxa, Praetors\' Voice', blueprintVersion: '',
    expansionName: 'Double Masters', foil: false, maxQuantity: 4, buyPrice: 150.00, buylistStoreCreditPrice: 165.00,
    image_url: 'https://cards.scryfall.io/normal/front/d/0/d0d33d52-3d28-4635-b985-51e126289259.jpg?1599707796',
    topCommander: true, topEdhCard: false, modernStaple: false, premodernStaple: false, reservedList: false, gameChanger: false,
  },
  {
    buylistID: 10, cardBlueprintId: 1010, blueprintName: 'Korvold, Fae-Cursed King', blueprintVersion: '',
    expansionName: 'Throne of Eldraine', foil: false, maxQuantity: 4, buyPrice: 85.00, buylistStoreCreditPrice: 93.50,
    image_url: 'https://cards.scryfall.io/normal/front/6/0/607c1793-8e5a-4ebf-87c6-7f9c99bbd29a.jpg?1752944988',
    topCommander: true, topEdhCard: false, modernStaple: false, premodernStaple: false, reservedList: false, gameChanger: false,
  },
  {
    buylistID: 11, cardBlueprintId: 1011, blueprintName: 'Yawgmoth, Thran Physician', blueprintVersion: '',
    expansionName: 'Dominaria Remastered', foil: false, maxQuantity: 4, buyPrice: 110.00, buylistStoreCreditPrice: 121.00,
    image_url: 'https://cards.scryfall.io/normal/front/b/5/b5a79f5d-d0df-4799-ac3a-84305e3af0c9.jpg?1675199878',
    topCommander: true, topEdhCard: false, modernStaple: true, premodernStaple: false, reservedList: false, gameChanger: false,
  },

  // --- Top EDH Cards (commander staples) ---
  {
    buylistID: 12, cardBlueprintId: 1012, blueprintName: 'Rhystic Study', blueprintVersion: '',
    expansionName: 'Jumpstart', foil: false, maxQuantity: 8, buyPrice: 220.00, buylistStoreCreditPrice: 242.00,
    image_url: 'https://cards.scryfall.io/normal/front/d/6/d6914dba-0d27-4055-ac34-b3ebf5802221.jpg?1600698439',
    topCommander: false, topEdhCard: true, modernStaple: false, premodernStaple: false, reservedList: false, gameChanger: false,
  },
  {
    buylistID: 13, cardBlueprintId: 1013, blueprintName: 'Smothering Tithe', blueprintVersion: '',
    expansionName: 'Commander Masters', foil: false, maxQuantity: 8, buyPrice: 180.00, buylistStoreCreditPrice: 198.00,
    image_url: 'https://cards.scryfall.io/normal/front/8/6/861b5889-0183-4bee-afeb-a4b2aa700a8e.jpg?1689996018',
    topCommander: false, topEdhCard: true, modernStaple: false, premodernStaple: false, reservedList: false, gameChanger: false,
  },
  {
    buylistID: 14, cardBlueprintId: 1014, blueprintName: 'Dockside Extortionist', blueprintVersion: '',
    expansionName: 'Double Masters 2022', foil: false, maxQuantity: 4, buyPrice: 350.00, buylistStoreCreditPrice: 385.00,
    image_url: 'https://cards.scryfall.io/normal/front/9/e/9e2e3efb-75cb-430f-b9f4-cb58f3aeb91b.jpg?1727093692',
    topCommander: false, topEdhCard: true, modernStaple: false, premodernStaple: false, reservedList: false, gameChanger: false,
  },
  {
    buylistID: 15, cardBlueprintId: 1015, blueprintName: 'Fierce Guardianship', blueprintVersion: '',
    expansionName: 'Commander Masters', foil: false, maxQuantity: 4, buyPrice: 200.00, buylistStoreCreditPrice: 220.00,
    image_url: 'https://cards.scryfall.io/normal/front/f/7/f7f3dd95-bd14-4e0f-a388-444f9cf1b0dc.jpg?1767727540',
    topCommander: false, topEdhCard: true, modernStaple: false, premodernStaple: false, reservedList: false, gameChanger: false,
  },
  {
    buylistID: 16, cardBlueprintId: 1016, blueprintName: 'Cyclonic Rift', blueprintVersion: '',
    expansionName: 'Ravnica Remastered', foil: false, maxQuantity: 8, buyPrice: 160.00, buylistStoreCreditPrice: 176.00,
    image_url: 'https://cards.scryfall.io/normal/front/d/f/dfb7c4b9-f2f4-4d4e-baf2-86551c8150fe.jpg?1702429366',
    topCommander: false, topEdhCard: true, modernStaple: false, premodernStaple: false, reservedList: false, gameChanger: false,
  },
  {
    buylistID: 17, cardBlueprintId: 1017, blueprintName: 'Jeweled Lotus', blueprintVersion: '',
    expansionName: 'Commander Masters', foil: false, maxQuantity: 4, buyPrice: 400.00, buylistStoreCreditPrice: 440.00,
    image_url: 'https://cards.scryfall.io/normal/front/d/7/d7183700-6941-4a3d-a581-4f33bea795e9.jpg?1727093687',
    topCommander: false, topEdhCard: true, modernStaple: false, premodernStaple: false, reservedList: false, gameChanger: true,
  },
  {
    buylistID: 18, cardBlueprintId: 1018, blueprintName: 'Mana Crypt', blueprintVersion: '',
    expansionName: 'Double Masters', foil: false, maxQuantity: 4, buyPrice: 900.00, buylistStoreCreditPrice: 990.00,
    image_url: 'https://cards.scryfall.io/normal/front/4/d/4d960186-4559-4af0-bd22-63baa15f8939.jpg?1727298349',
    topCommander: false, topEdhCard: true, modernStaple: false, premodernStaple: false, reservedList: false, gameChanger: true,
  },
  {
    buylistID: 19, cardBlueprintId: 1019, blueprintName: 'Sol Ring', blueprintVersion: '',
    expansionName: 'Commander Masters', foil: false, maxQuantity: 20, buyPrice: 15.00, buylistStoreCreditPrice: 16.50,
    image_url: 'https://cards.scryfall.io/normal/front/1/4/14dbce79-1fcc-4cc9-bf38-7729e44a411e.jpg?1771424544',
    topCommander: false, topEdhCard: true, modernStaple: false, premodernStaple: false, reservedList: false, gameChanger: false,
  },
  {
    buylistID: 20, cardBlueprintId: 1020, blueprintName: 'Command Tower', blueprintVersion: '',
    expansionName: 'Commander Masters', foil: false, maxQuantity: 20, buyPrice: 5.00, buylistStoreCreditPrice: 5.50,
    image_url: 'https://cards.scryfall.io/normal/front/4/d/4d51a621-be31-4b74-8e0b-3958180a8bc5.jpg?1771424570',
    topCommander: false, topEdhCard: true, modernStaple: false, premodernStaple: false, reservedList: false, gameChanger: false,
  },
  {
    buylistID: 21, cardBlueprintId: 1021, blueprintName: 'Arcane Signet', blueprintVersion: '',
    expansionName: 'Commander Masters', foil: false, maxQuantity: 20, buyPrice: 8.00, buylistStoreCreditPrice: 8.80,
    image_url: 'https://cards.scryfall.io/normal/front/0/4/049ca0ff-0ca4-44f7-b144-731cf453afa9.jpg?1771424531',
    topCommander: false, topEdhCard: true, modernStaple: false, premodernStaple: false, reservedList: false, gameChanger: false,
  },
  {
    buylistID: 22, cardBlueprintId: 1022, blueprintName: 'The Great Henge', blueprintVersion: '',
    expansionName: 'Commander Masters', foil: false, maxQuantity: 4, buyPrice: 270.00, buylistStoreCreditPrice: 297.00,
    image_url: 'https://cards.scryfall.io/normal/front/6/3/6340e0f3-7f9c-4d71-8daf-e1be5505eb5b.jpg?1689998574',
    topCommander: false, topEdhCard: true, modernStaple: false, premodernStaple: false, reservedList: false, gameChanger: false,
  },
  {
    buylistID: 23, cardBlueprintId: 1023, blueprintName: 'Esper Sentinel', blueprintVersion: '',
    expansionName: 'Modern Horizons 2', foil: false, maxQuantity: 8, buyPrice: 75.00, buylistStoreCreditPrice: 82.50,
    image_url: 'https://cards.scryfall.io/normal/front/f/3/f3537373-ef54-4578-9d05-6216420ee349.jpg?1626093502',
    topCommander: false, topEdhCard: true, modernStaple: true, premodernStaple: false, reservedList: false, gameChanger: false,
  },
  {
    buylistID: 24, cardBlueprintId: 1024, blueprintName: 'Doubling Season', blueprintVersion: '',
    expansionName: 'Foundations', foil: false, maxQuantity: 4, buyPrice: 300.00, buylistStoreCreditPrice: 330.00,
    image_url: 'https://cards.scryfall.io/normal/front/f/2/f2c4f80e-84a0-463b-82c3-5c6503809351.jpg?1730489400',
    topCommander: false, topEdhCard: true, modernStaple: false, premodernStaple: false, reservedList: false, gameChanger: false,
  },

  // --- Premodern Staples ---
  {
    buylistID: 25, cardBlueprintId: 1025, blueprintName: 'Force of Will', blueprintVersion: '',
    expansionName: 'Dominaria Remastered', foil: false, maxQuantity: 4, buyPrice: 550.00, buylistStoreCreditPrice: 605.00,
    image_url: 'https://cards.scryfall.io/normal/front/8/9/89f612d6-7c59-4a7b-a87d-45f789e88ba5.jpg?1753711891',
    topCommander: false, topEdhCard: false, modernStaple: false, premodernStaple: true, reservedList: false, gameChanger: true,
  },
  {
    buylistID: 26, cardBlueprintId: 1026, blueprintName: 'Gaea\'s Cradle', blueprintVersion: '',
    expansionName: 'Urza\'s Saga', foil: false, maxQuantity: 2, buyPrice: 5500.00, buylistStoreCreditPrice: 6050.00,
    image_url: 'https://cards.scryfall.io/normal/front/2/5/25b0b816-0583-44aa-9dc5-f3ff48993a51.jpg?1562902898',
    topCommander: false, topEdhCard: true, modernStaple: false, premodernStaple: true, reservedList: true, gameChanger: true,
  },
  {
    buylistID: 27, cardBlueprintId: 1027, blueprintName: 'City of Traitors', blueprintVersion: '',
    expansionName: 'Tempest Remastered', foil: false, maxQuantity: 4, buyPrice: 1800.00, buylistStoreCreditPrice: 1980.00,
    image_url: 'https://cards.scryfall.io/normal/front/7/1/71624139-a255-48be-93ca-594a4beba487.jpg?1562429861',
    topCommander: false, topEdhCard: false, modernStaple: false, premodernStaple: true, reservedList: true, gameChanger: false,
  },
  {
    buylistID: 28, cardBlueprintId: 1028, blueprintName: 'Mox Diamond', blueprintVersion: '',
    expansionName: 'Tempest Remastered', foil: false, maxQuantity: 2, buyPrice: 3200.00, buylistStoreCreditPrice: 3520.00,
    image_url: 'https://cards.scryfall.io/normal/front/b/f/bf9fecfd-d122-422f-bd0a-5bf69b434dfe.jpg?1562431287',
    topCommander: false, topEdhCard: false, modernStaple: false, premodernStaple: true, reservedList: true, gameChanger: false,
  },
  {
    buylistID: 29, cardBlueprintId: 1029, blueprintName: 'Wasteland', blueprintVersion: '',
    expansionName: 'Eternal Masters', foil: false, maxQuantity: 8, buyPrice: 180.00, buylistStoreCreditPrice: 198.00,
    image_url: 'https://cards.scryfall.io/normal/front/a/a/aaafb9bc-7cea-4624-a227-595544fa42b0.jpg?1590511888',
    topCommander: false, topEdhCard: false, modernStaple: false, premodernStaple: true, reservedList: false, gameChanger: false,
  },
  {
    buylistID: 30, cardBlueprintId: 1030, blueprintName: 'Rishadan Port', blueprintVersion: '',
    expansionName: 'Masters 25', foil: false, maxQuantity: 4, buyPrice: 250.00, buylistStoreCreditPrice: 275.00,
    image_url: 'https://cards.scryfall.io/normal/front/d/2/d2507bc2-da17-4e46-b4c5-ba0080ce2c6f.jpg?1562441604',
    topCommander: false, topEdhCard: false, modernStaple: false, premodernStaple: true, reservedList: true, gameChanger: false,
  },
];

// --- Mock service implementations ---

const hasActiveCategory = (filters?: BuylistFilters): boolean => {
  if (!filters) return false;
  return filters.reservedList || filters.gameChanger || filters.topCommander ||
    filters.topEdhCard || filters.premodernStaple || filters.modernStaple;
};

const matchesCategories = (item: MockBuylistItem, filters?: BuylistFilters): boolean => {
  if (!filters || !hasActiveCategory(filters)) return true;
  // OR logic: item passes if it matches ANY active category
  if (filters.reservedList && item.reservedList) return true;
  if (filters.gameChanger && item.gameChanger) return true;
  if (filters.topCommander && item.topCommander) return true;
  if (filters.topEdhCard && item.topEdhCard) return true;
  if (filters.premodernStaple && item.premodernStaple) return true;
  if (filters.modernStaple && item.modernStaple) return true;
  return false;
};

const applyFilters = (
  items: MockBuylistItem[],
  filters?: BuylistFilters,
  priceFilter?: PriceFilter,
  expansionName?: string,
): MockBuylistItem[] => {
  let result = items;

  result = result.filter(item => matchesCategories(item, filters));

  if (priceFilter?.minPrice !== undefined) {
    result = result.filter(item => item.buyPrice >= priceFilter.minPrice!);
  }
  if (priceFilter?.maxPrice !== undefined) {
    result = result.filter(item => item.buyPrice <= priceFilter.maxPrice!);
  }
  if (expansionName) {
    result = result.filter(item => item.expansionName === expansionName);
  }

  return result;
};

export const mockFetchBuylistItems = async (
  page = 0,
  size = 20,
  sortBy = 'buyMultiplier',
  sortDirection = 'desc',
  filters?: BuylistFilters,
  priceFilter?: PriceFilter,
  expansionName?: string,
): Promise<PagedResponse<BuylistItem>> => {
  const filtered = applyFilters(MOCK_ITEMS, filters, priceFilter, expansionName);

  filtered.sort((a, b) => {
    const aVal = (a as any)[sortBy] ?? 0;
    const bVal = (b as any)[sortBy] ?? 0;
    return sortDirection === 'desc' ? bVal - aVal : aVal - bVal;
  });

  const start = page * size;
  const content = filtered.slice(start, start + size);

  return {
    content,
    page,
    size,
    totalElements: filtered.length,
    totalPages: Math.ceil(filtered.length / size),
  };
};

export const mockFetchFeaturedCards = async (
  category: string,
  count = 5,
): Promise<BuylistItem[]> => {
  const filtered = MOCK_ITEMS.filter(item => (item as any)[category] === true);
  filtered.sort((a, b) => b.buyPrice - a.buyPrice);
  return filtered.slice(0, count);
};

export const mockFetchPriceRange = async (): Promise<PriceRangeResponse> => {
  const prices = MOCK_ITEMS.map(i => i.buyPrice);
  return {
    minPris: Math.min(...prices),
    maxPris: Math.max(...prices),
  };
};

export const mockFetchExpansionNames = async (): Promise<string[]> => {
  const names = new Set(MOCK_ITEMS.map(i => i.expansionName));
  return Array.from(names).sort();
};

export const mockSearchBuylistItems = async (
  query: string,
  filters?: BuylistFilters,
  priceFilter?: PriceFilter,
  expansionName?: string,
): Promise<BuylistItem[]> => {
  const lowerQuery = query.toLowerCase();
  let results = MOCK_ITEMS.filter(item =>
    item.blueprintName.toLowerCase().includes(lowerQuery),
  );
  results = applyFilters(results, filters, priceFilter, expansionName) as MockBuylistItem[];
  results.sort((a, b) => b.buyPrice - a.buyPrice);
  return results;
};

export const mockGetBuylistAutocomplete = async (query: string): Promise<string[]> => {
  if (!query.trim()) return [];
  const lowerQuery = query.toLowerCase();
  const names = MOCK_ITEMS
    .filter(item => item.blueprintName.toLowerCase().includes(lowerQuery))
    .map(item => item.blueprintName);
  return Array.from(new Set(names)).slice(0, 10);
};

export const mockFetchBuylistItemById = async (id: number): Promise<BuylistItem> => {
  const item = MOCK_ITEMS.find(i => i.buylistID === id || i.cardBlueprintId === id);
  if (!item) throw new Error(`Mock item not found: ${id}`);
  return item;
};
